import React from 'react';

import { Text } from '@betterment/samba-react';

import { ModalSectionRow } from '../../../../Shared/components-v2/modal-section/ModalSectionRow';

type Props = {
  beneficiaryName?: string | null;
  ascensusAccountNumber?: string | null;
};

export const Five29PlanDetails: React.FC<React.PropsWithChildren<Props>> = ({
  beneficiaryName,
  ascensusAccountNumber,
}) => {
  return (
    <>
      {beneficiaryName && (
        <ModalSectionRow key={beneficiaryName}>
          <ModalSectionRow.LeadingContent>
            <Text>Beneficiary</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{beneficiaryName}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
      )}
      {ascensusAccountNumber && (
        <ModalSectionRow key={ascensusAccountNumber}>
          <ModalSectionRow.LeadingContent>
            <Text>Account Number</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{ascensusAccountNumber}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
      )}
    </>
  );
};
